<script setup lang="ts">
import { cva } from 'class-variance-authority';
import { cn } from '@/helpers/tailwind-helpers';

import BaseLabel from '@/atoms/BaseLabel.vue';
import { computed } from 'vue';

export type RowItemButtonProps = {
  id: string | number;
  title: string;
  selected?: boolean;
  bordered?: boolean;
  titleColor?:
    | 'white'
    | 'primary'
    | 'success'
    | 'secondary'
    | 'brand'
    | 'tertiary'
    | 'placeholder'
    | 'error';
  class?: string;
};

const props = withDefaults(defineProps<RowItemButtonProps>(), {
  bordered: true,
});
const rowItem = cva('flex items-center space-x-2 py-3 px-4', {
  variants: {
    selected: {
      true: 'bg-brand-solid text-white rounded-xl',
      false: 'text-primary',
    },
    bordered: {
      true: 'border-b border-secondary',
      false: '',
    },
  },
  defaultVariants: {
    selected: false,
  },
});

const classes = computed(() => cn(rowItem(props), props.class));
</script>

<template>
  <article :class="classes">
    <div class="flex space-x-2 items-center">
      <slot />
      <BaseLabel preset="medium" :text="title" :color="titleColor" class="wrap-break-word" />
    </div>
  </article>
</template>
